import React from "react";
import { Headline } from "../styles/components/section";

const KeyComponent = props => {
  const componentContent = Object.values(props[0].content)
    .filter(component => component.__typename === "DatoCmsHeadline")
    .map(component => ({
      key: component.id,
      type: component.__typename,
      content: component.text,
    }));

  return (
    <>
      {componentContent.map(component => {
        switch (component.type) {
          case "DatoCmsHeadline":
            return <Headline key={component.key}>{component.content}</Headline>;
          default:
            return null;
        }
      })}
    </>
  );
};

export default KeyComponent;
